import React from "react"
import SectionTitle from "./SectionTitle"
import { StaticImage } from "gatsby-plugin-image"
import services from "../constants/services"

const Services = ({ img, className, children }) => {
  return (
    <div className=" services-bg  ">
 {/*      <StaticImage
        src="../assets/images/bg-5.png"
        alt="services-background"
        className="services-img"
        placeholder="tracedSVG"
      
      /> */}
      <div className=" section ">
        <div className="section-center">
          <SectionTitle
            className="title-left"
            pretitle="What do I offer"
            title="My skills"
            subtitle="I am a naturally curious problem 
            solver continuously working on improving my 
            chops one web developer problem at a time."
          />

          <div className="section-center services-center">
            {services.map(service => {
              const { id, icon, title, text } = service
              return (
                <article key={id} className="service">
                  {icon}
                  <h4 className="pre-title">{title}</h4>
                  <p>{text}</p>
                </article>
              )
            })}
          </div>
        </div>
      </div>
      {children}
    </div>
  )
}

export default Services
